import Cookies from 'js-cookie';

/**
 * 调用后端 AI 流式接口（SSE over POST）
 * @param {string} endpoint 接口路径，如 /api/ai/complete
 * @param {object} params 请求参数
 * @param {object} options { signal: AbortSignal, onDelta: (text) => void }
 * @returns {Promise<void>} 流结束(done 事件)时 resolve
 */
export function streamAi(endpoint, params, options = {}) {
  const { signal, onDelta } = options;
  const url = `${process.env.VUE_APP_API_URL}${endpoint}`;
  const token = Cookies.get('token') || '';

  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Auth-Token': token,
        Accept: 'text/event-stream',
      },
      body: JSON.stringify(params),
      signal,
    })
      .then(async (response) => {
        if (!response.ok) {
          let detail = '';
          try {
            detail = await response.text();
          } catch (e) {
            // ignore
          }
          throw new Error(`AI 请求失败(${response.status})${detail ? '：' + detail : ''}`);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';

        const handleEvent = (name, data) => {
          if (name === 'delta') {
            try {
              const parsed = JSON.parse(data);
              if (parsed.content && typeof onDelta === 'function') {
                onDelta(parsed.content);
              }
            } catch (e) {
              // 忽略无法解析的数据
            }
          } else if (name === 'done') {
            resolve();
          } else if (name === 'error') {
            try {
              const parsed = JSON.parse(data);
              reject(new Error(parsed.message || 'AI 服务异常'));
            } catch (e) {
              reject(new Error(data || 'AI 服务异常'));
            }
          }
        };

        const parseBuffer = () => {
          const parts = buffer.split('\n\n');
          buffer = parts.pop();
          for (const part of parts) {
            let eventName = null;
            const dataLines = [];
            for (const line of part.split('\n')) {
              if (line.startsWith('event:')) {
                eventName = line.slice(6).trim();
              } else if (line.startsWith('data:')) {
                dataLines.push(line.slice(5).trim());
              }
            }
            if (eventName) {
              handleEvent(eventName, dataLines.join('\n'));
            }
          }
        };

        try {
          for (;;) {
            const { done, value } = await reader.read();
            if (done) {
              break;
            }
            buffer += decoder.decode(value, { stream: true });
            parseBuffer();
          }
          parseBuffer();
          resolve();
        } catch (err) {
          if (err.name === 'AbortError') {
            reject(err);
          } else {
            reject(new Error('AI 流式读取失败：' + err.message));
          }
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}
